import { Dispatch } from '../../../../../types/actions';
import { ISnackbarModel, SnackbarVariant } from '../../store/types';
import { SNACKBAR_BUTTON_OK } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { SNACKBAR_TIMER_INFO } from '../../hocs/SnackbarHOC/constants';

export const snackbarInfoDefault = (
    options: ISnackbarModel
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [{
                onClick: () => dispatch(getDefaultActionEvent(options.id)),
                text: SNACKBAR_BUTTON_OK
            }];
        }
        if (options.timer === undefined) options.timer = SNACKBAR_TIMER_INFO;
        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            variant: SnackbarVariant.INFO,
            onTimer: () => dispatch(getDefaultActionEvent(options.id)),
        }));
    }
};
